import React, {useRef, useState} from 'react';
import {Input, Modal} from 'antd';
import Draggable from 'react-draggable';
import "./index.css";

const AddNewBankPopup = ({
                             Visible,
                             setIsAddBankPopup,
                             ocrBankDetails,
                             handleInputBankingChange,
                             setBankValues,
                             bankValues
                         }) => {
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(true);

    const [bounds, setBounds] = useState({
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    });
    const draggleRef = useRef(null);
    const showModal = () => {
        setOpen(true);
    };
    const handleOk = (e) => {
        const initialBankValues = {
            BankName: '',
            Accountnumber: '',
            SWIFT: '',
            IFSC: '',
            IBAN: '',
            BankCurrencyCode: ''
        };

        // Later, when you want to clear the state
        setBankValues(initialBankValues);
        setIsAddBankPopup(false);

    };
    const handleCancel = (e) => {

        ocrBankDetails.splice([ocrBankDetails.length - 1], 1);
        const initialBankValues = {
            BankName: '',
            Accountnumber: '',
            SWIFT: '',
            IFSC: '',
            IBAN: '',
            BankCurrencyCode: ''
        };
        setBankValues(initialBankValues);
        setIsAddBankPopup(false);
    };
    const onStart = (_event, uiData) => {
        const {clientWidth, clientHeight} = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    };
    return (
        <>

            <Modal
                title={
                    <div
                        style={{
                            width: '100%',
                            cursor: 'move',
                        }}
                        onMouseOver={() => {
                            if (disabled) {
                                setDisabled(false);
                            }
                        }}
                        onMouseOut={() => {
                            setDisabled(true);
                        }}
                        // fix eslintjsx-a11y/mouse-events-have-key-events
                        // https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/mouse-events-have-key-events.md
                        onFocus={() => {
                        }}
                        onBlur={() => {
                        }}
                        // end
                    >
                        Add new bank
                    </div>
                }
                wrapClassName="add-new-bank"
                open={Visible}
                onOk={handleOk}
                onCancel={handleCancel}
                modalRender={(modal) => (
                    <Draggable
                        disabled={disabled}
                        bounds={bounds}
                        nodeRef={draggleRef}
                        onStart={(event, uiData) => onStart(event, uiData)}
                    >
                        <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
            >

                <div className="flex mb-6 items-center gap-2">
                    <label className="w-36 not-italic font-normal text-sm leading-[17px] text-black">
                        Bank Name
                    </label>
                    <Input
                        className="rounded-xl"
                        allowClear
                        id="BankName"
                        value={bankValues.BankName}

                        onChange={(e) => handleInputBankingChange(e, [ocrBankDetails.length - 1])}
                    />

                </div>
                <div className="flex mb-6 gap-2 items-center">
                    <label className="w-36 not-italic font-normal text-sm leading-[17px] text-black">
                        Account Number
                    </label>
                    <Input
                        id="Accountnumber"
                        className="rounded-xl"
                        allowClear
                        value={bankValues.Accountnumber}
                        onChange={(e) => handleInputBankingChange(e, [ocrBankDetails.length - 1])}
                    />

                </div>
                <div className="flex mb-6 items-center gap-2">
                    <label className="w-36 not-italic font-normal text-sm leading-[17px] text-black">
                        SWIFT
                    </label>
                    <Input
                        id="SWIFT"
                        className="rounded-xl"
                        allowClear
                        value={bankValues.SWIFT}

                        onChange={(e) => handleInputBankingChange(e, [ocrBankDetails.length - 1])}
                    />

                </div>
                <div className="flex mb-6 items-center gap-2">
                    <label className="w-36 not-italic font-normal text-sm leading-[17px] text-black">
                        IFSC
                    </label>
                    <Input
                        id="IFSC"
                        className="rounded-xl"
                        allowClear
                        value={bankValues.IFSC}
                        onChange={(e) => handleInputBankingChange(e, [ocrBankDetails.length - 1])}
                    />

                </div>
                <div className="flex mb-6 items-center gap-2">
                    <label className="w-36 not-italic font-normal text-sm leading-[17px] text-black">
                        IBAN
                    </label>
                    <Input
                        id="IBAN"
                        className="rounded-xl"
                        allowClear
                        value={bankValues.IBAN}

                        onChange={(e) => handleInputBankingChange(e, [ocrBankDetails.length - 1])}
                    />

                </div>
                <div className="flex mb-6 items-center gap-2">
                    <label className="w-28 not-italic font-normal text-sm leading-[17px] text-black">
                        Currency
                    </label>
                    <Input
                        id="BankCurrencyCode"
                        className="rounded-xl w-24 "
                        allowClear
                        value={bankValues.BankCurrencyCode}

                        onChange={(e) => handleInputBankingChange(e, [ocrBankDetails.length - 1])}
                        style={{textAlign: 'right'}}
                    />

                </div>

            </Modal>
        </>
    );
};
export default AddNewBankPopup;
